import React from 'react';

import style from './index.module.scss';
import Folder from '../../../../assets/images/Example.svg';

const CounterpartyInfo: React.FC = () => {
  const downloadReportExample = () => {
    // @ts-ignore
    window.document.location = '/api/static-files/Пример_отчета.zip';
  };

  return (
    <>
      <h1 className={style.header}>Проверка контрагента</h1>

      <div className={style.description}>
        <div className={style.info}>
          <div className={style.infoDescription}>
            <h3 className={style.infoTitle}>Сервис включает в себя:</h3>
            <div className={style.infoItems}>
              <div className={style.infoRow}>
                <div className={style.infoItem}>
                  <h4 className={style.itemHeader}>Экспресс—отчёт</h4>
                  <p className={style.itemDescription}>
                    Результаты проверки организации <br /> в одном удобном документе.
                  </p>
                </div>
                <div className={style.infoItem}>
                  <h4 className={style.itemHeader}>Выписка из ЕГРЮЛ</h4>
                  <p className={style.itemDescription}>Официальные сведения о деятельности организации.</p>
                </div>
                <div className={style.infoItem}>
                  <h4 className={style.itemHeader}>Финансовая аналитика</h4>
                  <p className={`${style.itemDescription} ${style.itemDescriptionShort}`}>
                    Подробный анализ финансового положения эффективности деятельности организации.
                  </p>
                </div>
              </div>
              <div className={style.infoRow}>
                <div className={style.infoItem}>
                  <h4 className={style.itemHeader}>Проверка на аффилированность</h4>
                  <p className={style.itemDescription}>
                    Результаты автоматизированной проверки юридических связей между компаниями и физическими лицами. В
                    один клик вы получаете информацию о взаимоотношениях по интересующему вас юридическому лицу.
                  </p>
                </div>
                <div className={style.infoItem}>
                  <h4 className={style.itemHeader}>Реестр исполнения контрактов</h4>
                  <p className={style.itemDescription}>
                    Сформированный перечень контрактов и договоров, заключенных по итогам закупок в рамках 44-ФЗ и
                    223-ФЗ, а также статус их исполнения.
                  </p>
                </div>
                <div className={style.infoItem}>
                  <button
                    className={style.example}
                    type="button"
                    aria-label="Пример отчета"
                    onClick={downloadReportExample}
                  >
                    <img src={Folder} className={style.folder} alt="Посмотреть пример отчета" />
                    Посмотрите пример отчёта
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CounterpartyInfo;
